export enum DecisionType {
  approveAnnualAccount = "approveAnnualAccount",
  approveAuditorRemuneration = "approveAuditorRemuneration",
  approveCompanyBoardRemuneration = "approveCompanyBoardRemuneration",
  approveNominationCommitteeRemuneration = "approveNominationCommitteeRemuneration",
  assignsNewCompanyBoard = "assignsNewCompanyBoard",
  auditor = "auditor",
  accountant = "accountant",
  boardAssignsSignature = "boardAssignsSignature",
  capitalIncreaseThroughBonusIssue = "capitalIncreaseThroughBonusIssue",
  changeBusinessPurpose = "changeBusinessPurpose",
  changeOfAddress = "changeOfAddress",
  changeOfBusinessManager = "changeOfBusinessManager",
  changeCompanyBoardInArticlesOfAssociation = "changeCompanyBoardInArticlesOfAssociation",
  changeSignatureInArticlesOfAssociation = "changeSignatureInArticlesOfAssociation",
  companyName = "companyName",
  convertibleLoanPowerOfAttorney = "convertibleLoanPowerOfAttorney",
  dissolveCompany = "dissolveCompany",
  dividend = "dividend",
  dividendPowerOfAttorney = "dividendPowerOfAttorney",
  electNominationCommittee = "electNominationCommittee",
  employmentOfManagingDirector = "employmentOfManagingDirector",
  freetext = "freetext",
  groupContributionByGeneralMeeting = "groupContributionByGeneralMeeting",
  increaseOfShareCapital = "increaseOfShareCapital",
  increaseShareCapitalPowerOfAttorney = "increaseShareCapitalPowerOfAttorney",
  acquireOwnSharesPowerOfAttorney = "acquireOwnSharesPowerOfAttorney",
  insertCompanyBoardInArticlesOfAssociation = "insertCompanyBoardInArticlesOfAssociation",
  insertSignatureInArticlesOfAssociation = "insertSignatureInArticlesOfAssociation",
  interimBalanceSheet = "interimBalanceSheet",
  liquidateCompany = "liquidateCompany",
  procura = "procura",
  reductionOfShareCapital = "reductionOfShareCapital",
  removeCompanyBoardFromArticlesOfAssociation = "removeCompanyBoardFromArticlesOfAssociation",
  removeSignatureFromArticlesOfAssociation = "removeSignatureFromArticlesOfAssociation",
  reverseSplitShare = "reverseSplitShare",
  splitShare = "splitShare",
  noAuditor = "noAuditor",
  noAccountant = "noAccountant",
  noBusinessManager = "noBusinessManager",
  noManagingDirector = "noManagingDirector",
  changeArticlesOfAssociation = "changeArticlesOfAssociation",
  conversionOfShares = "conversionOfShares",
  electionOfCompanyBoard = "electionOfCompanyBoard",
  incorporation = "incorporation",
  merger = "merger",
  shareTransferConsent = "shareTransferConsent",
  optionGrantLetter = "optionGrantLetter",
  optionExercise = "optionExercise",
}

export const isDecisionType = (o: unknown): o is DecisionType =>
  typeof o === "string" && o in DecisionType;
